/* eslint-disable angular/constant-name */

angular.module("dx.webapp.roles").constant("RoleTypeEnum",
	Object.freeze({
		PUB: 0,
		STUDENT: 1,
		TEACHER: 2,
		ADMIN: 4,
		MASTER: 8,
		ACCOUNTMANAGER: 16,
		INVIGILATOR: 32,
	})
);
